import React from 'react'
import Button from 'components/Button/index.js'
import Text from 'components/Text.js'

/**
 * @param color
 * @param onClick
 * @param children
 * @param disabled
 * @returns {Element}
 * @constructor
 */
export default function ModalFooterButton ({
  color,
  onClick,
  children,
  disabled
}) {
  return (
    <Button
      onClick={onClick}
      isFullWidth
      disabled={disabled}
      hoverableProps={{
        f: 1
      }}
      style={{
        justifyContent: 'center'
      }}
    >
      <Text
        fw='510'
        c={color || '#151D21'}
        fs='0.9375em'
      >
        {children}
      </Text>
    </Button>
  )
}
